export const steps = {
  LISTINGS: 'listings',
  PRODUCTS: 'products',
  HIGHLIGHTS: 'highlights',
  COVER: 'cover',
  PREVIEW: 'preview',
};

export const templates = {
  DAO: 'dao',
  NO_LOGO: 'no-logo',
};

// listings.internal_product — the "Owned By" field. One list so the listing
// form and the intake sections of the New Stock / New Consignment flows cannot
// drift apart. `owned` carries the store's own name (per-store branding); the
// other three are fixed labels.
export const TO_BE_PROCURED = 'to_be_procured';

export const ownedByOptions = (storeName) => [
  { id: 'no', name: 'Merchants' },
  { id: 'owned', name: storeName ?? 'RC' },
  { id: 'exclusive', name: 'Consignment' },
  { id: TO_BE_PROCURED, name: 'To Be Procured' },
];

// Chip labels for the Owned By filter (see RCFilters / ListingSearch). The
// panel's own list is server-fed so it carries counts; these only have to be
// right on the removable chips, where `owned` reads as the agreed generic
// "Stock" rather than the store's name.
export const OWNED_BY_FILTER_LABELS = {
  no: 'Merchants',
  owned: 'Stock',
  exclusive: 'Consignment',
  [TO_BE_PROCURED]: 'To Be Procured',
};
